<template>
  <div>
    <HeaderComponent v-show="$route.name !== 'greeting'"></HeaderComponent>
    <router-view class="app"></router-view>
  </div>
</template>

<script>
import HeaderComponent from "@/components/header";
export default {
  components: {
    HeaderComponent,
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Goldman&family=Press+Start+2P&display=swap");

html {
  background-color: #171717;
  height: 100vh;
  box-sizing: border-box;
  position: relative;
}

* {
  box-sizing: border-box;
}

.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}

.centredInfo {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/*BUTTON ESTETIC*/
button {
  font-family: "Press Start 2P";
  padding: 10px;
  border: 3px solid #ef8232;
  background-color: #f7c544;
  font-size: 20px;
  color: #d72d20;
  text-decoration: none !important;
}
</style>
